import { AbstractControl, NgForm } from '@angular/forms';
import { Component, EventEmitter, Input,  OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SharedDataService, SuppliersService, PafListsService } from '../../all-services';
import { Supplier, SupplierStatut, SupplierStatutsNext, SimpleReponseResult, PS_Get_Buttons_Result, WFMotif,  Family, ChangeStatutParams } from '../../all-models';
import { Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { SupplierStatutBadgeSize } from '../supplier-statut-badge/supplier-statut-badge.component';

export class BeforeValidateClickEvent {
  public cancel: boolean = false;
  public button: PS_Get_Buttons_Result;
  public supplierId: number;
}

export class supplierStatutChangeEvent {
  SupplierId: number;
  Button: PS_Get_Buttons_Result;
}

@Component({
  selector: 'supplier-validation-toolbar',
  templateUrl: './supplier-validation-toolbar.component.html',
  styleUrls: ['./supplier-validation-toolbar.component.scss']
})
export class SupplierValidationToolbarComponent implements OnInit, OnChanges, OnDestroy {

  @Input() supplier?: Supplier;
  @Output() supplierStatutChanged: EventEmitter<supplierStatutChangeEvent> = new EventEmitter<supplierStatutChangeEvent>();
  @Input() validationdisabled: boolean = false;
  @Output() beforevalidateclick: EventEmitter<BeforeValidateClickEvent> = new EventEmitter<BeforeValidateClickEvent>();
  @Input() validationclickconfirm?: Observable<void>;
  private validationclickconfirmSubscription?: Subscription = null;


   badgeSize : SupplierStatutBadgeSize = SupplierStatutBadgeSize.LARGE;

  @ViewChild('ngfrmvalidstatut') ngfrmvalidstatut: NgForm;


  public historyWindowOptions: any = {
    visible: false,
    width: 1200,
    height: 500,
    top: 0,
    left: undefined,
    state: 'default'
  }

  public windowsValid: any = {
    visible: false,
    width: 700,
    height: 400,
    state: 'default'
  }

  public lstFamilies: Family[] = [];
  public lstWFMotifs: WFMotif[] = [];
  public changeStatutParams: ChangeStatutParams = new ChangeStatutParams();
  public codMotifSel: string = null;

  public clickedButton?: PS_Get_Buttons_Result = null;

  get selectedMotif():WFMotif | undefined {
    return this.lstWFMotifs.find(m=>m.Cod==this.codMotifSel);
  }

  getWindowsValidTitle(): string {
    if (!this.clickedButton) return 'Validation';
    return this.clickedButton.BtnLib;
  }

  lstStatuts: SupplierStatut[] = [];
  constructor(
    private suppliersSvc: SuppliersService,
    private pafLists: PafListsService,
    public sharedDataSvc: SharedDataService) { }

    subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.pafLists.getSupplierStatuts().subscribe((lst: SupplierStatut[]) => this.lstStatuts = lst);
    this.pafLists.getWFMotifs().subscribe((lst: WFMotif[]) => {
      this.lstWFMotifs = lst;
    });
    this.pafLists.getFamilies().subscribe((lst: Family[]) => this.lstFamilies = lst);
    this.subscriptions.push(
      this.sharedDataSvc.loggedProfilChange.subscribe(res => this.reloadAll())
    );
  }

  private reloadAll(): void {
    this.reloadButtons();
    //this.reloadHistory();
  }

  ngOnDestroy(): void {
    if (this.validationclickconfirmSubscription != null) this.validationclickconfirmSubscription.unsubscribe();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  get clickedStatut(): SupplierStatut | undefined {
    return this.lstStatuts.find(s => s.Id == this.clickedButton?.StatutId);
  }
  public nextButtons: PS_Get_Buttons_Result[] = [];



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['supplier']) {
      this.reloadAll();
    }
    if (changes['validationclickconfirm'] && this.validationclickconfirm != null) {
      if (this.validationclickconfirmSubscription != null) this.validationclickconfirmSubscription.unsubscribe();
      this.validationclickconfirmSubscription = this.validationclickconfirm.subscribe((res: void) => {
        let btnValidation: PS_Get_Buttons_Result = this.nextButtons.find(b => b.IsValidationBtn);
        if (btnValidation) {
          this.btnChangeStatutClic(btnValidation, 3);
        }
      });
    }
  }

  reloadButtons(): void {
    if (this.supplier) {
      this.suppliersSvc.GetButtons(this.supplier.Id)
        .subscribe((lst: PS_Get_Buttons_Result[]) => {
          this.nextButtons = lst;
        });
    }
  }

  get buttonsVisible(): boolean {
    return (!this.historyWindowOptions.visible)
      && this.sharedDataSvc.portalType == 'INTRANET'
      && this.supplierStatut && ['010', '100'].indexOf(this.supplierStatut.Cod) < 0;
  }



  btnNgClass(statutNext: SupplierStatutsNext): any {
    let displayNone = '';
    if (this.supplierStatut && ['010', '100'].indexOf(this.supplierStatut.Cod) >= 0) {
      displayNone = ' d-none';
    }
    return 'btn btn-xs btn-' + this.suppliersSvc.StatutCss(statutNext.IdNext) + displayNone;
  }

  btnLib(statutNext: SupplierStatutsNext): string {
    const statut: SupplierStatut = this.suppliersSvc.lstStatut.find(s => s.Id == statutNext.IdNext);
    if (!statut) return '';
    return (this.sharedDataSvc.portalType == 'EXTRANET') ? statut.LblCodExtranet : statut.LblCod;
  }

  get supplierStatut(): SupplierStatut | null {
    if (this.supplier) {
      return this.suppliersSvc.supplierStatut(this.supplier);
    } else {
      return null;
    }
  }

  get currentCod(): string | undefined {
    return this.supplierStatut?.Cod;
  }
  get buttonCod(): string | undefined {
    if (!this.clickedButton) return undefined;
    return this.clickedButton.IsPriseEnChargeBtn == 1 ? 'PRISE EN CHARGE' :
      this.clickedButton.IsValidationBtn == 1 ? 'VALIDATION' :
        this.clickedButton.IsRefusBtn == 1 ? 'REFUS' :
          this.clickedButton.IsRetourFouBtn == 1 ? 'RETOUR FOU' :
            this.clickedButton.IsRetourAchatBtn == 1 ? 'RETOUR ACHAT' :
              this.clickedButton.IsProspectBtn == 1 ? 'PROSPECT' :
                this.suspensionEnCours ? 'SUSPENSION' :
                  this.annulationSuspensionEnCours ? 'ANNULESUSPENSION' :
                    undefined;
  }


  public lstButtonMotifs: WFMotif[];

  public CanSave(f: NgForm): boolean {
    let avecError: boolean = false;
    Object.keys(f.controls).forEach((key, i) => {
      let control: AbstractControl = f.controls[key];
      control.markAsTouched();
      if (control.errors != null) {
        avecError = true;
        return;
      }
    });
    return !avecError;
  }
  //step = 1 : 1er appel par click directement sur le bouton(affiche modale ou validation avec evenement beforeclick qui peut annuler la validation)
  //step = 2 : 2nd appel par validation via fenetre modale
  //step = 3 : Equivaut à step 1 sans contrôle de before click
  btnChangeStatutClic(button: PS_Get_Buttons_Result, step: number): void {
    this.suppliersSvc.CanChangeStatut(this.supplier.Id)
      .subscribe((canChange: boolean) => {
        if (!canChange) {
          this.sharedDataSvc.pafAlert('Utilisateur_non_autorise_a_changer_le_statut_du_fournisseur');
          return;
        }
        this.clickedButton = button;
        if (step == 1 && button.ExitScreen == 0 && !button.IsReactivationBtn) {
          this.codMotifSel = null;
          this.changeStatutParams = new ChangeStatutParams();
          this.btnChangeStatutClic(button, 2);
          return;
        }
        if (step == 1 && button.IsValidationBtn == 1) {
          let param: BeforeValidateClickEvent = new BeforeValidateClickEvent();
          param.supplierId = this.supplier?.Id;
          param.button = button;
          param.cancel = false;
          this.beforevalidateclick.emit(param);
          if (param.cancel) {
            this.sharedDataSvc.WindowUnlock();
            return;
          }
        }
        if (step == 1 || step == 3) {
          if (button.IsValidationBtn == 1) {
            let supValMotif: WFMotif = this.lstWFMotifs.find(m => m.Id == this.supplier?.MotifValId);
            this.codMotifSel = supValMotif?.Cod;
          } else if (button.IsRefusBtn == 1) {
            let supRefusMotif: WFMotif = this.lstWFMotifs.find(m => m.Id == this.supplier?.MotifRefusId);
            this.codMotifSel = supRefusMotif?.Cod;
          } else {
            this.codMotifSel = null;
          }
          this.changeStatutParams = new ChangeStatutParams();
          this.pafLists.PostButtonMotifs(button).subscribe(res => {
            this.lstButtonMotifs = res;
            this.lstButtonMotifs.sortObject('Rank');
            this.showWindowsValid(true);
          });
          return;
        }
        if (this.windowsValid.visible) {
          if (!this.CanSave(this.ngfrmvalidstatut)) {
            this.sharedDataSvc.pafAlert('Champs_en_erreur');
            return;
          }
        }
        this.changeStatutParams.SupplierId = this.supplier.Id;
        this.changeStatutParams.NewStatutId = button.StatutId;
        this.changeStatutParams.CurrentStatutId = this.supplier.StatutId;
        this.changeStatutParams.MailModelCod = button.MailCod;
        this.changeStatutParams.WFMotifId = this.lstWFMotifs.find(m => m.Cod == this.codMotifSel)?.Id;
        this.changeStatutParams.PressedButton = button;
        let preTraitement: Observable<Supplier>;

        if (button.StatutCod == '800' && button.IsValidationBtn == 1) {
          let patchSupplier: Supplier = new Supplier();
          patchSupplier.Id = this.supplier?.Id;
          patchSupplier.NumTiers = this.supplier?.NumTiers;
          preTraitement = this.suppliersSvc.PatchSimpleValues(this.supplier.Id, patchSupplier, 'NumTiers')
                            .pipe(map(result=>{            
                              return this.supplier;
                            }));
        } else {
          preTraitement = of(this.supplier);
        }
        this.sharedDataSvc.WindowLock();
        preTraitement.subscribe((result: Supplier) => {
          this.suppliersSvc.PostChangeStatut(result.Id, this.changeStatutParams)
            .subscribe((response: SimpleReponseResult) => {
              if (response.Ok) {
                this.showWindowsValid(false);
                let param: supplierStatutChangeEvent = new supplierStatutChangeEvent();
                param.Button = button;
                param.SupplierId = this.supplier.Id;
                if (button.ExitScreen == 0) {
                  this.suppliersSvc.getSupplier(this.supplier.Id)
                    .subscribe((res: Supplier) => {
                      this.supplier = res;
                      this.reloadButtons();
                      //this.reloadHistory();
                      this.clickedButton = null;
                      this.lstButtonMotifs = [];
                      this.changeStatutParams = new ChangeStatutParams();
                      this.sharedDataSvc.WindowUnlock();
                    });
                } else {
                  this.clickedButton = null;
                  this.lstButtonMotifs = [];
                  this.changeStatutParams = new ChangeStatutParams();
                  this.sharedDataSvc.WindowUnlock();
                }
                this.supplierStatutChanged.emit(param);
              } else {
                this.sharedDataSvc.WindowUnlock();
                this.sharedDataSvc.alert(response.Message);
              }
            });
        });
      });
  }

  get pafCssHeader(): string {
    if (!this.clickedButton) return '';
    return this.clickedButton.BtnClass.replace('btn btn-xs btn-', 'bg-');
  }

  showHistory(visible: boolean): void {
    this.historyWindowOptions.visible = visible;
  }

  showWindowsValid(visible: boolean): void {
    if (!visible) {
      this.suspensionEnCours = false;
      this.annulationSuspensionEnCours = false;
    }
    this.windowsValid.visible = visible;
  }

  get commentsRequired(): boolean {
    if (!this.windowsValid.visible || !this.clickedButton) return false;
    if (this.clickedButton.CommentsRequired == 1) {
      return true;
    }
    else if (this.lstButtonMotifs.length > 0) {
      return ((this.codMotifSel || '') == '');
    } else {
      return (this.clickedButton.IsRefusBtn == 1
        || this.clickedButton.IsRetourAchatBtn == 1
        || this.clickedButton.IsRetourFouBtn == 1);
    }
  }

  get mainFamily(): Family | undefined {
    return this.lstFamilies.find(f => f.Id == this.supplier?.SupplierFamilies?.find(sf => sf.MainFamily == 1)?.FamilyId);
  }


  getFamilyDisplay = function (family: Family, withCod: boolean) {
    if (!family) return '';
    let prefix: string = withCod ? family.Cod + ' - ' : '';
    if (family.ParentId == null) return prefix + family.Segment;
    let ret: string = prefix + family.Segment + '/' + family.FamilyCod;
    if (family.SubFamilyCod) ret += '/' + family.SubFamilyCod;
    return ret;
  }
  get isAdmin(): boolean {
    return this.sharedDataSvc?.profil?.Cod == 'ADMIN';
  }

  public suspensionEnCours: boolean = false;
  showSuspension(): void {
    if (!this.supplier) return;
    this.lstButtonMotifs = [];
    this.suspensionEnCours = true;
    this.clickedButton = new PS_Get_Buttons_Result();
    this.clickedButton.StatutCodPrec = this.supplierStatut?.Cod;
    this.clickedButton.StatutIdPrec = this.supplierStatut?.Id;
    this.clickedButton.CommentsRequired = 1;
    this.clickedButton.StatutCod = '900';
    this.clickedButton.StatutId = this.lstStatuts.find(st => st.Cod == '900')?.Id;
    this.clickedButton.BtnClass = 'btn btn-xs btn-danger';
    this.clickedButton.BtnLib = 'BtnStatuts/SUSPENSION';
    this.clickedButton.ExitScreen = 0;
    this.showWindowsValid(true);

  }
  public annulationSuspensionEnCours: boolean = false;
  annuleSuspension(): void {
    if (!this.supplier) return;
    this.lstButtonMotifs = [];
    this.annulationSuspensionEnCours = true;
    this.clickedButton = new PS_Get_Buttons_Result();
    this.clickedButton.StatutCodPrec = this.supplierStatut?.Cod;
    this.clickedButton.StatutIdPrec = this.supplierStatut?.Id;
    this.clickedButton.CommentsRequired = 1;
    this.suppliersSvc.GetAllWorkFlow(this.supplier.Id)
      .subscribe(wfs => {
        // On supprime le flux de suspension et on trie par Id de wf décroissant pour récupérer le flux précédent
        wfs = wfs.filter(wf => wf.SupplierWF.SupplierStatut?.Cod != '900');
        wfs.sortObjectDesc('Id');
        if (wfs.length > 0) {
          let previousStatut: SupplierStatut = wfs[0].SupplierWF.SupplierStatut;
          this.clickedButton.StatutCod = previousStatut.Cod;
          this.clickedButton.StatutId = previousStatut.Id;
          this.clickedButton.BtnClass = 'btn btn-xs btn-success';
          this.clickedButton.BtnLib = 'BtnStatuts/ANNULE_SUSPENSION';
          this.clickedButton.ExitScreen = 0;
          this.showWindowsValid(true);
        }
      });
  }

  get supplierTitle(): string {
    if (!this.supplier) return '';
    const Sep = (this.supplier?.NumTiers || '') == '' ? '' : ' - ';
    return (this.supplier?.NumTiers || '') + Sep + this.supplier?.SupplierName;
  }

  get suspensionBtn(): PS_Get_Buttons_Result | undefined {
    return this.nextButtons.find(b=>b.IsSuspensionBtn);
  }

  get reactivationBtn(): PS_Get_Buttons_Result | undefined {
    return this.nextButtons.find(b=>b.IsReactivationBtn);
  }

}
